'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _FooterBlock = require('./FooterBlock.scss');

var _FooterBlock2 = _interopRequireDefault(_FooterBlock);

var _reactIntl = require('react-intl');

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _session = require('redux/modules/session');

var _search = require('redux/modules/search');

var _helpers = require('utils/helpers');

var _countries = require('utils/countries');

var _price = require('utils/price');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  FooterBlock: {
    displayName: 'FooterBlock'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Footer/FooterBlock.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

// import DestinationSelect from 'components/General/DestinationSelect';
_momentTimezone2.default.tz.setDefault('Asia/Bangkok');

var FooterBlock = _wrapComponent('FooterBlock')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    destinations: state.info.destinations,
    path: state.routing.locationBeforeTransitions.pathname,
    trip: state.trip.data,
    sessionData: state.session.data,
    messages: state.language.messages,
    locale: state.language.locale,
    groupDestinationsByCountry: state.info.siteConfigs.groupDestinationsByCountry,
    userConfig: state.info.userConfig,
    tourType: state.session.tourType
  };
}, (0, _extends3.default)({}, _reactRouterRedux.routerActions, { setSessionData: _session.setSessionData, loadSessionData: _session.loadSessionData, setFilter: _search.setFilter, setLocalSessionData: _session.setLocalSessionData })), _dec2 = (0, _reactCssModules2.default)(_FooterBlock2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(FooterBlock, _Component);

  function FooterBlock() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FooterBlock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FooterBlock.__proto__ || (0, _getPrototypeOf2.default)(FooterBlock)).call.apply(_ref, [this].concat(args))), _this), _this.onChangeCurrency = function (event) {
      event.target.blur();
      var value = event.target.value;
      _this.props.setLocalSessionData({ currency: value });
      _this.props.setSessionData({ currency: value });
    }, _this.onChangeCountry = function (e) {
      e.target.blur();
      var country = _countries.countryMap[e.target.value];
      var updatedObj = {
        userType: {
          type: country,
          selected_at: (0, _momentTimezone2.default)().toDate()
        },
        currency: (0, _price.getDefaultCurrency)(e.target.value)
      };
      _this.props.setLocalSessionData(updatedObj);
      _this.props.setSessionData(updatedObj);
      _reactGa2.default.set({ dimension1: country }, ['auTracker']);
      _reactGa2.default.event({ category: 'User', action: 'Classify User' }, ['auTracker']);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FooterBlock, [{
    key: 'render',
    value: function render() {
      var facebookImage = require('./facebook.png');
      var twitterImage = require('./twitter.png');
      var pintarestImage = require('./pinterest.png');
      var googleImage = require('./google.png');
      var sessionData = this.props.sessionData;

      var country = sessionData.userType ? _countries.inverseCountryMap[sessionData.userType.type] : '';
      return _react3.default.createElement(
        'div',
        { styleName: 'col-footer-list' },
        _react3.default.createElement(
          'div',
          { styleName: 'mobile-show', style: { marginBottom: 10 } },
          _react3.default.createElement(
            'div',
            { styleName: 'currency-row' },
            _react3.default.createElement(
              'div',
              { styleName: 'label' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.footerblock.currency.label' }),
              ' : '
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'dropdown' },
              _react3.default.createElement(
                'select',
                { onChange: this.onChangeCurrency, value: sessionData.currency },
                _helpers.currencies.map(function (cur) {
                  return _react3.default.createElement(
                    'option',
                    { value: cur.value, key: cur.value },
                    cur.label
                  );
                })
              )
            )
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'mobile-show' },
          _react3.default.createElement(
            'div',
            { styleName: 'currency-row' },
            _react3.default.createElement(
              'div',
              { styleName: 'label' },
              'Country : '
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'dropdown' },
              _react3.default.createElement(
                'select',
                { onChange: this.onChangeCountry, value: country },
                _react3.default.createElement(
                  'option',
                  { value: '', disabled: true },
                  'Please select'
                ),
                _countries.countries.map(function (c) {
                  return _react3.default.createElement(
                    'option',
                    { value: c.value, key: c.value },
                    c.label
                  );
                })
              )
            )
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'mobile-hide', style: { marginBottom: 10 } },
          _react3.default.createElement(
            'div',
            { styleName: 'row-label' },
            _react3.default.createElement(
              'h4',
              { styleName: 'currency-title' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.footerblock.currency.label' })
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'row-select' },
            _react3.default.createElement(
              'div',
              { styleName: 'dropdown' },
              _react3.default.createElement(
                'select',
                { onChange: this.onChangeCurrency, value: sessionData.currency },
                _helpers.currencies.map(function (cur) {
                  return _react3.default.createElement(
                    'option',
                    { value: cur.value, key: cur.value },
                    cur.label
                  );
                })
              )
            )
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'mobile-hide' },
          _react3.default.createElement(
            'div',
            { styleName: 'row-label' },
            _react3.default.createElement(
              'h4',
              { styleName: 'currency-title' },
              'Country'
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'row-select' },
            _react3.default.createElement(
              'div',
              { styleName: 'dropdown' },
              _react3.default.createElement(
                'select',
                { onChange: this.onChangeCountry, value: country },
                _react3.default.createElement(
                  'option',
                  { value: '', disabled: true },
                  'Please select'
                ),
                _countries.countries.map(function (c) {
                  return _react3.default.createElement(
                    'option',
                    { value: c.value, key: c.value },
                    c.label
                  );
                })
              )
            )
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'row-follow' },
          _react3.default.createElement(
            'h4',
            { styleName: 'follow-title' },
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.footerblock.follow' })
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'mobile-show' },
          _react3.default.createElement(
            'div',
            { styleName: 'row-social' },
            _react3.default.createElement(
              'a',
              { target: '_blank', href: 'https://www.facebook.com/Takemetour', rel: 'noopener noreferrer' },
              _react3.default.createElement('img', { src: facebookImage, width: '39', alt: 'TakeMeTour\'s Facebook' })
            ),
            _react3.default.createElement(
              'a',
              { target: '_blank', href: 'https://twitter.com/takemetour', rel: 'noopener noreferrer' },
              _react3.default.createElement('img', { src: twitterImage, width: '39', alt: 'TakeMeTour\'s Twitter' })
            ),
            _react3.default.createElement(
              'a',
              { target: '_blank', href: 'https://www.pinterest.com/TakeMeTour/', rel: 'noopener noreferrer' },
              _react3.default.createElement('img', { src: pintarestImage, width: '39', alt: 'TakeMeTour\'s Pinterest' })
            ),
            _react3.default.createElement(
              'a',
              { target: '_blank', href: 'https://plus.google.com/+Takemetour', rel: 'noopener noreferrer' },
              _react3.default.createElement('img', { src: googleImage, width: '39', alt: 'TakeMeTour\'s Google' })
            )
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'mobile-hide' },
          _react3.default.createElement(
            'div',
            { styleName: 'row-social' },
            _react3.default.createElement(
              'a',
              { target: '_blank', href: 'https://www.facebook.com/Takemetour', rel: 'noopener noreferrer' },
              _react3.default.createElement('img', { src: facebookImage, width: '30', alt: 'TakeMeTour\'s Facebook' })
            ),
            _react3.default.createElement(
              'a',
              { target: '_blank', href: 'https://twitter.com/takemetour', rel: 'noopener noreferrer' },
              _react3.default.createElement('img', { src: twitterImage, width: '30', alt: 'TakeMeTour\'s Twitter' })
            ),
            _react3.default.createElement(
              'a',
              { target: '_blank', href: 'https://www.pinterest.com/TakeMeTour/', rel: 'noopener noreferrer' },
              _react3.default.createElement('img', { src: pintarestImage, width: '30', alt: 'TakeMeTour\'s Pinterest' })
            ),
            _react3.default.createElement(
              'a',
              { target: '_blank', href: 'https://plus.google.com/+Takemetour', rel: 'noopener noreferrer' },
              _react3.default.createElement('img', { src: googleImage, width: '30', alt: 'TakeMeTour\'s Google' })
            )
          )
        )
      );
    }
  }]);
  return FooterBlock;
}(_react2.Component), _class2.propTypes = {
  destinations: _react2.PropTypes.array,
  onChange: _react2.PropTypes.func,
  push: _react2.PropTypes.func,
  path: _react2.PropTypes.string,
  trip: _react2.PropTypes.object,
  setLocalSessionData: _react2.PropTypes.func,
  setSessionData: _react2.PropTypes.func,
  loadSessionData: _react2.PropTypes.func,
  setFilter: _react2.PropTypes.func,
  sessionData: _react2.PropTypes.object,
  messages: _react2.PropTypes.object,
  locale: _react2.PropTypes.string,
  groupDestinationsByCountry: _react2.PropTypes.bool,
  userConfig: _react2.PropTypes.object,
  tourType: _react2.PropTypes.string
}, _class2.defaultProps = {
  destinations: {}
}, _temp2)) || _class) || _class));

exports.default = FooterBlock;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/FooterBlock.js
// module id = 1520
// module chunks = 47